import React from "react";
import { Link } from "react-router-dom";
import Item from "../models/item";

function CatalogItem(props: { item: Item, items: Item[], showSizes: boolean, lazyLoad: boolean }) {
    return (
        <div className="pt-3 text-start">
            <Link
                className="text-body text-decoration-none"
                to={`/p/${props.item.slug}/`}
                title={`Джинси ${props.item.name} ${props.item.id}`}
            >
                <div className="mb-3" style={{ width: "100%" }}> {/* Hook to reserve height == width during loading */}
                    <div style={{ height: "0", paddingBottom: "100%" }}> {/* Hook to reserve height == width during loading */}
                        {props.item.tag &&
                            <div className="position-relative">
                                <span className="position-absolute top-0 start-0 badge rounded-pill bg-secondary p-1 text-uppercase fw-bold" style={{lineHeight: 0.75}}>{props.item.tag}</span>
                            </div>
                        }
                        <img className="img-fluid" width="100%" height="100%" src={props.item.imageCatalog} loading={props.lazyLoad ? "lazy" : "eager"} alt={`Оригінальні чоловічі джинси ${props.item.name} у кольорі ${props.item.color}`} />
                    </div>
                </div>
                <span className="d-block mb-2" style={{height: "calc(var(--bs-body-font-size) * 1.5 * 3)", lineHeight: "calc(var(--bs-body-font-size) * 1.5)", overflow: "hidden"}}>Джинси {props.item.name} {props.item.color}</span>
            </Link>
            <p className="mt-2 mb-1">
                <span className="h4">{props.item.price}</span>₴
            </p>
            {
                props.item.stockStatus == "outOfStock" ? <p className="text-secondary mb-2">Тимчасово немає в наявності</p> :
                props.item.stockStatus == "inStock" ? <p className="text-success mb-2">Є в наявності</p> :
                <p className="text-secondary mb-2">Очікується поставка</p>
            }
            {props.showSizes &&
                <div className="mb-2">
                    {props.items.map((size, i) => {
                        return (
                            <span className="badge bg-light text-dark fw-normal p-1 border mb-1 me-1" style={{ fontSize: "0.875rem" }}>
                                {size.waist}-{size.length}
                            </span>
                        )
                    })}
                </div>
            }
        </div>
    );
}

export default CatalogItem;